// @flow
import LonLat from './Projection.LonLat';
import SphericalMercator from './Projection.SphericalMercator';

function getProjection(epsg) {
    let project;
    switch (epsg) {
        case 'EPSG:4326':
        case 'EPSG:4214':
        case 'EPSG:4490':
        case 'EPSG:4610': {
            project = new LonLat();
            break;
        }
        case 'EPSG:3857': {
            project = new SphericalMercator();
            break;
        }
        default: {
            throw new Error('未找到坐标系对应的投影信息');
        }
    }
    return project;
}

export {getProjection};
